module.exports = __webpack_public_path__ + "static/media/kite_surfing_1366.92281666.jpg";